import { useSelector } from './use-selector.js';
import { MultiMeterBarChartState } from '../../types/state.js';

export const useMultiMeterBarState = () =>
  useSelector((state: MultiMeterBarChartState) => state);

export const useMultiMeterBarSegmentsState = () =>
  useSelector((state: MultiMeterBarChartState) => state.segments);

export const useMultiMeterBarVisibleSegmentsState = () =>
  useSelector((state: MultiMeterBarChartState) =>
    Array.from(state.visibleSegments).map(([, value]) => value),
  );

export const useMultiMeterBarHighlightedSegments = () =>
  useSelector((state: MultiMeterBarChartState) => state.highlightedSegments);

export const useMultiMeterBarTooltipState = () =>
  useSelector((state: MultiMeterBarChartState) => state.tooltip);
